<template>
  <div>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
  <script>
export default {
  name: "products",
  props: ["id", "model"],
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {
        model_type: this.model,
        model_id: this.id,
      },
      val: [],
      modalCreate: "ticket",
      fields: [
        {
          key: "name",
          col: "col-12",
          label: "Проблема",
          labelKey: "problem",
          type: "textarea",
        },
        {
          key: "media",
          col: "col-12",
          label: "Файл",
          labelKey: "file",
          type: "zip",
        },
        {
          key: "model_type",
          default: this.model,
          type: "hidden",
        },
        {
          key: "model_id",
          default: this.id,
          type: "hidden",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_ticket",
      itemLink: "tickets",
      setLink: "tickets",
      columns: [
        {
          key: "id",
          title: "ID",
        },
        {
          key: "name",
          title: "Название",
          titleKey: "name",
        },
        {
          key: "state",
          title: "Статус",
          titleKey: "state",
        },
        {
          key: "user",
          title: "Сотрудник",
          object: "name",
          titleKey: "employee",
          disableLink: true,
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
  <style>
</style>
  